export default __webpack_public_path__ + "static/media/rounded-front.0244822d.webp";